import * as Sentry from '@sentry/astro';

Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_DSN,
  // Conformidade LGPD: Desativa envio automático de dados pessoais e identificadores
  sendDefaultPii: false,
  // Amostragem de performance equilibrada para rastreamento de saúde sem sobrecarregar a rede
  tracesSampleRate: 0.1,
  // Desativa completamente o Session Replay (elimina gravação de tela, polifills legados e ~80 KiB de JS)
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  // Filtro de segurança e higienização de erros
  beforeSend(event, hint) {
    const error = hint.originalException;
    if (error && typeof error === 'object' && 'message' in error) {
      const msg = String((error as Error).message || '');
      // Filtra erros irrelevantes disparados por extensões de navegador ou cancelamento de requisição
      if (
        msg.includes('ResizeObserver loop limit exceeded') ||
        msg.includes('Extension context invalidated') ||
        msg.includes('The operation was aborted') ||
        msg.includes('Load failed')
      ) {
        return null;
      }
    }
    // Remove cabeçalhos e cookies potencialmente sensíveis antes do despacho
    if (event.request?.headers) {
      delete event.request.headers['cookie'];
      delete event.request.headers['authorization'];
    }
    return event;
  },
});
